
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 6C20.53 6 21.04 6.21 21.42 6.59C21.79 6.96 22 7.47 22 8V20C22 20.53 21.8 21.03 21.42 21.41C21.04 21.79 20.53 22 20 22H5C4.21 22 3.44 21.68 2.88 21.12C2.32 20.56 2 19.8 2 19V5C2 4.2 2.32 3.44 2.88 2.88C3.44 2.32 4.21 2 5 2H18C18.53 2 19.05 2.22 19.42 2.59C19.79 2.96 20 3.47 20 4V6ZM5 4C4.74 4 4.48 4.11 4.3 4.29C4.11 4.48 4 4.73 4 5C4 5.27 4.11 5.52 4.3 5.71C4.48 5.89 4.74 6 5 6H18V4H5ZM20 20V10.03V8H5C4.66 8 4.32 7.94 4 7.83V19C4 19.27 4.11 19.52 4.3 19.71C4.48 19.89 4.74 20 5 20H20ZM18.42 14C18.42 14.7456 17.8156 15.35 17.07 15.35C16.3244 15.35 15.72 14.7456 15.72 14C15.72 13.2544 16.3244 12.65 17.07 12.65C17.8156 12.65 18.42 13.2544 18.42 14Z","fill":"#16171F"}})])
          )
        }
      }
    